"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _connect = _interopRequireDefault(require("./connect"));

var _actions = require("./actions");

var _getFeatureId = _interopRequireDefault(require("./getFeatureId"));

var _ajax = require("rxjs/ajax");

var _operators = require("rxjs/operators");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default(_ref) {
  var projectId = _ref.projectId,
      apiUrl = _ref.apiUrl;

  var _connectLongPolling = (0, _connect.default)({
    projectId: projectId,
    apiUrl: apiUrl
  }, _ajax.ajax),
      features = _connectLongPolling.features,
      dispatch = _connectLongPolling.dispatch;

  features.connect();
  return function (_ref2) {
    var queryName = _ref2.queryName,
        args = _ref2.args; // subscribe to the feature

    dispatch(_actions.subscribeToFeature)(queryName, args);
    return features // feature selector
    .pipe( //map(features => features[getFeatureId(queryName, args)]),
    (0, _operators.pluck)((0, _getFeatureId.default)(queryName, args)), (0, _operators.pluck)("feature"), // if no feature then do not emit
    (0, _operators.filter)(Boolean) // finalize(()=>{ dispatch(unsubscribeFromFeature)(queryName, args)})
    );
  };
};

exports.default = _default;